import React from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

function AdminShell({ children }) {
  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default AdminShell;
